// src/composables/useFieldSync.ts
import { useEventBus } from '@vueuse/core'

// 定义 Payload 结构：包含字段名和值
interface SyncPayload {
  field: string // 关键：用来区分是哪个字段，例如 'title' | 'url' | 'content'
  value: any
}

export function useFieldSync(scopeName = 'GLOBAL_FORM_SYNC') {
  // 创建一个通用的总线
  const bus = useEventBus<SyncPayload>(scopeName)

  /**
   * 派发函数 (Sender)
   * @param field 字段标识 (如 'website')
   * @param value 要同步的值
   */
  const dispatchField = (field: string, value: any) => {
    bus.emit({ field, value })
    console.log(`[同步] 字段 ${field} 已广播`)
  }

  /**
   * 接收函数 (Receiver)
   * @param targetField 你关注的字段标识
   * @param callback 收到数据后的回调
   */
  const onFieldReceive = (targetField: string, callback: (val: any) => void) => {
    const unsubscribe = bus.on(payload => {
      // 核心逻辑：只有当广播里的 field 等于我关注的 targetField 时，才执行回调
      if (payload.field === targetField) {
        callback(payload.value)
      }
    })
    return unsubscribe
  }

  return { dispatchField, onFieldReceive }
}
